const project = {
  slug: "showzs-streaming",
  title: "SHOWZS - Live Streaming & Movies",
  oneLiner: "RTMP→HLS pipeline, subscription billing, secured media delivery.",
  role: ["App Project Lead", "Front-end Developer"],
  category: ["App Development", "Web Development"],
  clientOrOrg: "SHOWZS",
  timeframe: { start: "2024-07", end: "2024-09", status: "Shipped" },
  domain: ["Streaming", "Media"],
  tech: ["React", "Flutter", "Laravel", "MySQL", "AWS S3", "Nginx", "RTMP", "HLS"],
  links: { live: "https://showzs.com" },
  gallery: [
    {
      src: "/assets/showzs/showzs-1.png",
      alt: "SHOWZS home page showcasing live streaming and movie options"
    },
    {
      src: "/assets/showzs/showzs-2.png",
      alt: "showzs-2"
    },
  ],
  impact: [
    "Enabled paid live events and VOD with secure S3 delivery.",
    "Shipped CMS for content and plan management."
  ],
  responsibilities: [
    "Frontend architecture in React/Flutter",
    "Playback pipeline integration and protected routes"
  ],
  features: [
    "RTMP ingest → HLS playback",
    "Subscription billing and access control",
    "Admin CMS for events & media"
  ],
  architecture: [
    "Nginx/Node for RTMP ingest",
    "HLS packaging + signed URLs",
    "Laravel APIs + MySQL"
  ],
  seo: {
    title: "SHOWZS Streaming - RTMP to HLS Case Study",
    description:
      "Architected a streaming platform with RTMP to HLS, subscription billing, and secured S3 delivery using React, Flutter, Laravel, and Nginx."
  },
  cover: "/assets/showzs/showzs-featured.png"
};

export default project;
